module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0034.jpg?v=efbaa3f7";